import { render, staticRenderFns } from "./UserPublications.vue?vue&type=template&id=1d9c7a6f&scoped=true"
import script from "./UserPublications.vue?vue&type=script&lang=js"
export * from "./UserPublications.vue?vue&type=script&lang=js"
import style0 from "./UserPublications.vue?vue&type=style&index=0&id=1d9c7a6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9c7a6f",
  null
  
)

export default component.exports